import React from 'react';
import styles from './CardOptionWorkspaceAds.module.scss';
import { SFChip } from 'sfui';

export interface CardOptionWorkspaceAdsProps {}

export const CardOptionWorkspaceAds = (
  props: CardOptionWorkspaceAdsProps
): React.ReactElement<CardOptionWorkspaceAdsProps> => {
  return (
    <div className={styles.cardOptionWorkspaceAds}>
      <div className={styles.cardOptionWorkspaceAdsHeader}>
        <h2>Workspaces</h2>
        <span>
          <SFChip
            label="Coming Soon"
            sfColor={'primary'}
            variant={'outlined'}
            clickable={false}
          />
        </span>
      </div>
      <p>Centralize your Data, Scale your Impact</p>
    </div>
  );
};
